module.exports = __webpack_public_path__ + "static/media/expertnetwork-logo2.a95929ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/expertnetwork-logo2.png
// module id = 485
// module chunks = 0